import axios from "./_axios";
import { API } from "./apiEndPoints";

// ER-10294: polymorphic context files API, shared by all five entity types
// (responsibility|role|position|department|account) via object_type/object_id.
export const getContextFiles = (objectType, objectId) => {
  return axios()({
    method: "get",
    url: API.CONTEXT_FILES,
    params: { object_type: objectType, object_id: objectId },
  });
};

export const uploadContextFiles = (objectType, objectId, files, onUploadProgress) => {
  const formData = new FormData();
  formData.append("object_type", objectType);
  formData.append("object_id", objectId);
  Array.from(files).forEach((file) => formData.append("files", file));

  return axios()({
    method: "post",
    url: API.CONTEXT_FILES,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

export const deleteContextFile = (fileId) => {
  return axios()({
    method: "delete",
    url: `${API.CONTEXT_FILES}${fileId}/`,
  });
};

// Maps the backend EntityContextFileSerializer shape (file_name/content_type_mime/download_url)
// to the { id, name, contentType, url } shape ContextFiles.vue and FileReaderModal.vue expect.
export const mapContextFileToUi = (file) => ({
  id: file.id,
  name: file.file_name,
  contentType: file.content_type_mime,
  url: file.download_url,
});
